import store from "../store";

// This file sets the info for our backend calls

import axios from "axios";

// Productions checklist: Update baseURL for production

export default () => {
  if (process.env.NODE_ENV === "development") {
    return axios.create({
      baseURL: `http://localhost:8081/`,
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  } else {
    return axios.create({
      baseURL: `https://cuddlyghost.xyz/`,
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  }
};

// export default () => {
//   if(process.env.NODE_ENV === 'development'){
//       return axios.create({
//           baseURL: `http://localhost:8081/`
//       })
//   } else {
//       return axios.create({
//           baseURL: `https://everything-food.site/`
//       })
//   }
// }
